import React, { useState } from 'react';

export default function RedeemCategory({ title, cost, items, onRedeem }) {
  // track which button was just clicked (by href or label)
  const [clicked, setClicked] = useState(null);

  function handleClick(e, item) {
    // let the normal link still work (go hit /wh/... etc)
    // but give visual feedback immediately
    setClicked(item.href);

    // bubble up toast to parent App if provided
    if (onRedeem) {
      onRedeem(item.label);
    }

    // remove highlight after animation duration
    setTimeout(() => {
      setClicked(null);
    }, 500);
  }

  return (
    <div className="redeem-card">
      <div className="redeem-card-header">
        <h3 className="redeem-title">{title}</h3>
        <div className="redeem-cost">{cost}</div>
      </div>

      <div className="redeem-grid">
        {items.map(item => (
          <a
            key={item.href}
            href={item.href}
            className={
              "redeem-button" +
              (clicked === item.href ? " clicked" : "")
            }
            onClick={(e) => {
              // we DON'T preventDefault here because you actually want
              // the GET /wh/... to fire server-side.
              handleClick(e, item);
            }}
          >
            {item.label}
            <span className="redeem-sparkle" />
          </a>
        ))}
      </div>
    </div>
  );
}